import React, { useState } from 'react';
import { useCallback } from 'react';
import { useOnClickAway, useOnEscape, useScrollLock } from '@/helpers';
import { OverlayTypes, useOverlayStore } from '@/store/overlayStore';

interface UseDrawerResponse {
	isOpen: boolean;
	isRendered: boolean;
	handleOpen: () => void;
	handleClose: () => void;
}

export const useDrawer = (
	drawerRef: React.RefObject<HTMLDialogElement | HTMLDivElement>,
	onClose?: () => void,
): UseDrawerResponse => {
	const setScrollLock = useScrollLock();
	const setShowOverlay = useOverlayStore((state) => state.setShowOverlay);
	const [isOpen, setIsOpen] = useState(false);
	const [isRendered, setIsRendered] = React.useState(false);
	const drawerTransTime = 400; // should match value in CSS in Drawer

	const handleOpen = useCallback((): void => {
		setIsRendered(true);

		setTimeout(() => {
			setIsOpen(true);
			setShowOverlay(OverlayTypes.FULL);
			setScrollLock(true);
		}, 10);
	}, [setScrollLock, setShowOverlay]);

	const handleClose = useCallback((): void => {
		setIsOpen(false);
		setShowOverlay(false);
		setScrollLock(false);

		setTimeout(() => {
			setIsRendered(false);
			if (onClose) onClose();
		}, drawerTransTime);
	}, [onClose, setScrollLock, setShowOverlay]);

	useOnEscape(handleClose, isOpen);
	useOnClickAway(drawerRef, handleClose, isOpen);

	return { isOpen, isRendered, handleOpen, handleClose };
};
